import Lenis from 'lenis';

export default class SmoothScroll {
    constructor() {
        // only enable on mobile
        if (window.innerWidth > 768) {
            this.lenis = new Lenis({
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                direction: 'vertical',
                gestureDirection: 'vertical',
                smooth: true,
                smoothTouch: false,
                touchMultiplier: 2,
                anchors: true,
                overScroll: true,
                // Update prevent option to handle both nav menu and filter dropdowns
                prevent: (node) => {
                    // Check if the node or any of its parents has either class
                    const isNavMenu = node.closest('.c-nav_slideout_body') !== null;
                    const isFilterDropdown = node.closest('.c-filter_content') !== null;
                    const goalContent = node.closest('.c-goal_content_inner');
                    const propertyImages = node.closest('.c-img_spotlight_items');
                    
                    // Only check scrollability for goal content
                    if (goalContent) {
                        return goalContent.scrollHeight > goalContent.clientHeight ? node : false;
                    }

                    if (propertyImages) {
                        return propertyImages.scrollHeight > propertyImages.clientHeight ? node : false;
                    }
                    
                    return isNavMenu || isFilterDropdown;
                }
            });

            this.init();
            this.bindFilterEvents();
        }
    }

    init() {
        // Create the RAF loop
        const raf = (time) => {
            this.lenis.raf(time);
            requestAnimationFrame(raf);
        };
        requestAnimationFrame(raf);

        // Add GSAP ticker if using GSAP
        gsap.ticker.add((time) => {
            this.lenis.raf(time * 1000);
        });
    }

    bindFilterEvents() {
        // Get all filter content divs
        const filterContents = document.querySelectorAll('.c-filter_content');
        const goalContents = document.querySelectorAll('.c-goal_content_inner');

        filterContents.forEach(content => {
            content.addEventListener('mouseenter', () => {
                this.stop();
            });

            content.addEventListener('mouseleave', () => {
                this.start();
            });
        });

        // goalContents.forEach(content => {
        //     content.addEventListener('mouseenter', () => {
        //         this.stop();
        //     });

        //     content.addEventListener('mouseleave', () => {
        //         this.start();
        //     });
        // });
    }

    stop() {
        if (this.lenis) {
            this.lenis.stop();
        }
    }

    start() {
        if (this.lenis) {
            this.lenis.start();
        }
    }

    destroy() {
        if (this.lenis) {
            this.lenis.destroy();
        }
    }
} 